import type { Pricings } from '~/composables/types/event'

export const getPricingTotalPrice = (pricing: Pricings) => {
  return pricing.price.total_price
}

export const getPricingAppliedDiscount = (pricing: Pricings) => {
  return pricing.price.applied_discount
}

export const getPricingBasePrice = (pricing: Pricings) => {
  return pricing.price.base_price
}

export const getPricingPricePerPerson = (pricing: Pricings, title: string) => {
  return pricing.price_breakdown.find((item) => item.title === title)
    ?.price_per_person
}

/**
 * Calculates the discounted price after applying a promotion discount.
 *
 * @param originalPrice - The original price in base currency (e.g., euros)
 * @param promotion - The promotion object with discount and discount_type
 * @returns The discounted price, or undefined if no valid promotion
 *
 * @example
 * // Percentage discount
 * calculatePromotionDiscount(100, { discount: 20, discount_type: 'PERCENTAGE' })
 * // Returns: 80
 *
 * @example
 * // Fixed value discount (discount is in cents)
 * calculatePromotionDiscount(100, { discount: 2000, discount_type: 'FIXED_VALUE' })
 * // Returns: 80 (100 - 20)
 */
export const calculatePromotionDiscount = (
  originalPrice: number,
  promotion?: {
    discount?: number
    discount_type?: 'PERCENTAGE' | 'FIXED_VALUE'
  }
): number | undefined => {
  if (!promotion?.discount) {
    return undefined
  }

  if (promotion.discount_type === 'PERCENTAGE') {
    return originalPrice * (1 - promotion.discount / 100)
  }

  if (promotion.discount_type === 'FIXED_VALUE') {
    // discount is stored in cents, convert to base currency
    return Math.max(0, originalPrice - promotion.discount / 100)
  }

  return undefined
}
